import React, { FC, useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import { useMediaQuery, useTheme } from '@mui/material';
import { Route } from 'app/enums';
import { Box, Typography } from '@mui/material';
import { useBalancesConfig } from '../../hooks/use-balances-config';
import { useStyles } from './UserBalance.styles';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { RewardBalance } from './RewardBalance';
import { UserBalanceLine } from './UserBalanceLine';

export const UserBalance: FC = () => {
  const { classes } = useStyles();

  const theme = useTheme();
  const isBiggerThanMdScreen = useMediaQuery(theme.breakpoints.up('md'));
  const isLessThanXsScreen = useMediaQuery(theme.breakpoints.down('xs'));

  const rewardBalanceComponent = useMemo(
    () => <RewardBalance variant={isBiggerThanMdScreen ? 'large' : 'small'} />,
    [isBiggerThanMdScreen]
  );

  const { balancesConfig } = useBalancesConfig();

  return (
    <Box>
      {/* TODO: update styles/classes of balance in AppHeader to use Material. */}
      <div className="d-flex align-items-center justify-content-end v60">
        {rewardBalanceComponent && isBiggerThanMdScreen ? (
          <Box mr={1}>{rewardBalanceComponent}</Box>
        ) : null}
        <Typography variant="subtitle2" className={classes.textLink}>
          <NavLink to={Route.PaymentBalance}>
            <Box display="flex" flexDirection="column">
              <Box display="flex" alignItems="center">
                <AccountBalanceWalletIcon fontSize={isBiggerThanMdScreen ? 'large' : 'small'} />
                <Box display="flex" flexDirection="column" ml={1}>
                  {balancesConfig.map(
                    (line) =>
                      line.account && (
                        <UserBalanceLine
                          key={line.account.currency + line.account.balance}
                          account={line.account}
                          fiatEquivalent={line.fiatEquivalent}
                          size={isBiggerThanMdScreen ? 'medium' : 'small'}
                        />
                      )
                  )}
                </Box>
              </Box>
              {rewardBalanceComponent && !isBiggerThanMdScreen && !isLessThanXsScreen
                ? rewardBalanceComponent
                : null}
            </Box>
          </NavLink>
        </Typography>
      </div>
    </Box>
  );
};
